<template>
    <div class="loginfo-container">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
            <el-form :inline="true" :model="filters">
                <el-form-item label="关键字">
                    <el-input size="small" v-model="filters.search" placeholder="姓名，手机号关键字"></el-input>
                </el-form-item>
                <el-form-item>
                    <dateOptionSelector :options="dateOptions" v-model="filters.dateTime" :multiple="true" />
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" v-on:click="queryPageList">查询</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <!--列表-->
        <el-table stripe border size="mini" :data="tableData" highlight-current-row expand-on-click-node="false"
            style="width: 100%">
            <el-table-column fixed="left" prop="MemberTraining.TraningType" label="计划" width="120" sortable>
                <template slot-scope="scope">
                    <el-tag type="primary">{{ format.dateFormat(scope.row.MemberTraining.ScheduleBeginDate) }}</el-tag>
                    <el-tag type="danger">{{ format.dateFormat(scope.row.MemberTraining.ScheduleEndDate) }}</el-tag>

                </template>
            </el-table-column>
            <el-table-column fixed="left" prop="Member" label="姓名" width="120" sortable> <template slot-scope="scope">
                    <div class="link" v-if="scope.row.MemberTraining.Member">
                        {{ scope.row.MemberTraining.Member.RealName }} <el-tag type="primary">{{
                            scope.row.MemberTraining.Member.Mobile }}</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column fixed="left" prop="Date" label="计划日期/项目" width="120" sortable>
                <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.Date) }}
                    <el-tag type="primary">{{
                        scope.row.Name }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="ResponseDate" label="反馈时间" sortable>
                <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.ResponseDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="CompleteLevel" label="完成情况" sortable>
                <template slot-scope="scope">
                    {{ format.completeLevelsFormat(scope.row.CompleteLevel) }}
                </template>
            </el-table-column>
            <el-table-column prop="FatigueLevel" label="疲劳程度" sortable>
                <template slot-scope="scope">
                    {{ format.completeLevelsFormat(scope.row.FatigueLevel) }}
                </template>
            </el-table-column>
            <el-table-column prop="Minutes" label="训练总时长" sortable>
            </el-table-column>
            <el-table-column prop="CompleteTotal" label="动作数量" sortable>
            </el-table-column>
            <el-table-column prop="ImproveFeel" label="否感到获得提升" sortable>
                <template slot-scope="scope">
                    {{ format.improveFeelsFormat(scope.row.ImproveFeel) }}
                </template>
            </el-table-column>
            <el-table-column prop="Difficults" label="较难完成的动作" sortable>
                <template slot-scope="scope">
                    {{ scope.row.Difficults }}
                </template>
            </el-table-column>
            <el-table-column prop="Confusions" label="存在困惑的动作" sortable>
                <template slot-scope="scope">
                    {{ scope.row.Confusions }}
                </template>
            </el-table-column>
            <el-table-column prop="TrainingEffect" label="自我觉察" sortable>
                <template slot-scope="scope">
                    {{ scope.row.TrainingEffect }}
                </template>
            </el-table-column>
            <el-table-column prop="Satisfied" label="内容是否满意" sortable>
                <template slot-scope="scope">
                    {{ scope.row.Satisfied }}
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" :current-page.sync="pageIndex"></el-pagination>
        </div>
    </div>
</template>
<script>
import { GetTraningList } from "@/api/traning/traning";
import dateOptionSelector from "@/components/dateOptionSelector";
export default {
    components: {
        dateOptionSelector,
    },
    data() {
        return {
            filters: {
                search: "",
                traningType: "LowerLimbs",
                dateTime: {
                    dateType: "date",
                    date: [],
                },
            },
            dateOptions: [
                { value: "date", name: '计划日期' },
                { value: "response", name: '反馈时间' }
            ],
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            pageSizesList: [10, 15, 20, 30, 50],
        };
    },
    methods: {
        queryPageList: function () {
            let data = {
                pageSize: this.pageSize,
                traningType: this.filters.traningType,
                pageIndex: this.pageIndex,
                search: this.filters.search,
                dateType: this.filters.dateTime.dateType,
                beginDate:
                    this.filters.dateTime.date.length > 0
                        ? this.filters.dateTime.date[0]
                        : "",
                endDate:
                    this.filters.dateTime.date.length > 1
                        ? this.filters.dateTime.date[1]
                        : "",
            };
            GetTraningList(data).then((response) => {
                this.listLoading = false;
                if (response) {
                    this.tableData = response.Items;
                    this.total = response.Total || response.Items.length;
                }
            });
        },
        handleSizeChange(val) {
            var pageSize = `${val}`;
            this.pageIndex = 1;
            this.pageSize = parseInt(pageSize);
            this.$nextTick(() => this.queryPageList());
        },
        handleCurrentChange(val) {
            this.pageIndex = `${val}`;
            this.queryPageList();
        },
        handleDelete(row) {
            this.$confirm("确认删除该天计划吗？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let parma = { key: row.Key };
                del(parma).then((res) => {
                    if (res) {
                        this.queryPageList();
                    }
                });
            });
        },
    },
    mounted() {
        this.queryPageList();
    },
};
</script>

<style lang='scss' scoped>
.loginfo-container {
    padding: 10px;
}

/deep/.el-dialog {
    margin-top: 10px !important;
}
</style>
